import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionService } from '../../common/services/Session.service';
import { UtilityService } from '../../common/services/utility-service';
import { constObj } from '../../common/Constants/constants';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private router: Router, private session: SessionService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private utilityService: UtilityService) {
    this.isArchiveApplication();
    }
  help_header;
  help_description;
  help_topicsHeader;
  help_topicsDescription;
  help_mainNavigationLinks: string;
  help_mainNavigationLinksArchive: string;
  help_mainNavigationLinksProArchive: string;
  help_seeAlsoHeader;
  help_seeAlsoLinks;
  help_userGuidePro;
  help_userGuideBasic;
  s3bucketbasepath;
  archiveVersion: string = "";
  isArchive: boolean = false;
 
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.checkSession();
    this.graphQlService.getS3BucketImagePath().subscribe(data => {
      this.s3bucketbasepath = data;
    });
    this.gethelpcomponentlabels();
  }
  ngOnDestroy() {
    this.commonDataService.loadCurrentLeftNav.next(null);
  }
  //ngAfterViewChecked() {
  //  this.anchorColorChange();
  //}

  //anchorColorChange() {
  //  let item1 = document.getElementById('mainNavigationLinks').getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
  //  for (var i = 0; i < item1.length; i++) {
  //    let element = item1[i];
  //    element.style.color = "#005CBF";
  //  }
  //  let item2 = document.getElementById('help_otherFeaturesLinks').getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
  //  for (i = 0; i < item2.length; i++) {
  //    let element = item2[i];
  //    element.style.color = "#005CBF";
  //  }
  //  let item3 = document.getElementById('help_seeAlsoLinks').getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
  //  for (i = 0; i < item3.length; i++) {
  //    let element = item3[i];
  //    element.style.color = "#005CBF";
  //  }
  //}
  gethelpcomponentlabels() {
    this.graphQlService.getHelpComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.help_header = labels.filter(x => x.key == "help_header").map(y => y.value);
        this.help_description = labels.filter(x => x.key == "help_description").map(y => y.value);
        this.help_topicsHeader = labels.filter(x => x.key == "help_topicsHeader").map(y => y.value);
        this.help_topicsDescription = labels.filter(x => x.key == "help_topicsDescription").map(y => y.value);
        this.help_mainNavigationLinks = labels.filter(x => x.key == "help_mainNavigationLinks").map(y => y.value);
        this.help_mainNavigationLinksPro = labels.filter(x => x.key == "help_mainNavigationLinksPro").map(y => y.value);
        this.help_mainNavigationLinksArchive = labels.filter(x => x.key == "help_mainNavigationLinksArchive").map(y => y.value);
        this.help_mainNavigationLinksProArchive = labels.filter(x => x.key == "help_mainNavigationLinksProArchive").map(y => y.value);
        this.help_seeAlsoHeader = labels.filter(x => x.key == "help_seeAlsoHeader").map(y => y.value);
        this.help_userGuidePro = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "help_userGuidePro").map(y => y.value)); 
        this.help_userGuideBasic = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "help_userGuideBasic").map(y => y.value));
        this.commonDataService.showLoader.next(false);
      }
    });
  }
  help_mainNavigationLinksPro: string = "";
  userRole: string = "";
  checkSession() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.userRole = data.user.roles;
      })
    }
    else { this.userRole = this.session.userInfo.user.roles; }
  }

  navigateTo(event) {
    this.router.navigate([event.target.parentElement.target]);
  }
  openLinkById(event) {
    event.preventDefault();
    let id = event.target.getAttribute('id');
    let url = '/layoutComponents/getPdf?isSitesBucket=true&fileName=' + id;//show pdf
    window.open(url);

  }
  onRightClick(event) {
    let id = event.target.id;
    if (id != "") {
      event.target.href = this.s3bucketbasepath + "/" + event.target.id;
    }
  }
  isArchiveApplication() {
    this.archiveVersion = localStorage.getItem("ArchiveVersion");
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
      this.isArchive = Boolean(this.archiveVersion);
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId") && (this.archiveVersion != null && this.archiveVersion != undefined)) {
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.isArchive = Boolean(this.archiveVersion);
    }
    else { this.isArchive = false; }
  }
  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }
}
